export const NetworkConfig = {
    id: "",
    name: "",
    description: "",
    model: "MQ2-4G",
    server_id: "",
    server_name: "",
    mqtt_ids: [],
    mqtt_names: "",
    mqtt_type: "b",
    ntp_id: "",
    ntp_name: "",
    gps_id: "",
    gps_name: "",
    default: false,
}

export const NetworkConfigDetails = {
    id: 0,
    name: "",
    model: "",
    default: false,
    server: {
        id: "",
        name: "",
        model: "",
        has:{},
        values:{}
    },
    mqtt: {
        id: "",
        name: "",
        model: "",
        type: "b",
        has:{},
        values:{}
    },
    ntp: {
        id: "",
        name: "",
        description: "",
        has:{},
        values:{}
    },
    gps: {
        id: "",
        name: "",
        description: "",
        has:{},
        values:{}
    }
}